//@flow

type ActionType = "Modal/SET_MODAL"

type ModalAction = {
  type: ActionType,
  payload: {
    isModal: boolean
  }
}

type ModalState = {
  +isModal: boolean
}

export type SetModal = (isModal: boolean) => ModalAction

export const setModal: SetModal = (isModal: boolean): ModalAction => {
  return {
    type: "Modal/SET_MODAL",
    payload: { isModal }
  }
}

export const isModal = (state: { modal: ModalState }): boolean =>
  state.modal.isModal

export const reducer = (state: ModalState, action: ModalAction): ModalState => {
  switch (action.type) {
    case "Modal/SET_MODAL":
      return { ...state, isModal: action.payload.isModal }
    default:
      return state || false
  }
}



// WEBPACK FOOTER //
// ./src/Modal/redux.js